export interface Testimonial {
  id: string;
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: "test-001",
    name: "李晓明",
    role: "自由设计师",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20creative%20studio%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20friendly%20expression&width=120&height=120&seq=avatar-li-01&orientation=squarish",
    content: "黄油网站彻底改变了我的工作方式！以前做一张海报要2个小时，现在用模板10分钟搞定，客户满意度反而更高了。素材库的质量也非常高，强烈推荐！",
    rating: 5,
  },
  {
    id: "test-002",
    name: "王小芳",
    role: "新媒体运营",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20with%20warm%20smile%20in%20modern%20office%2C%20soft%20natural%20light%2C%20clean%20minimal%20background%2C%20friendly%20candid%20expression&width=120&height=120&seq=avatar-wang-02&orientation=squarish",
    content: "作为一个新媒体运营，每周要做几十张图。黄油网站让我的效率提升了不止一倍，而且模板更新很快，紧跟热点，再也不用担心灵感枯竭了。",
    rating: 5,
  },
  {
    id: "test-003",
    name: "张伟",
    role: "创业者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20man%20entrepreneur%20with%20confident%20expression%2C%20warm%20lighting%2C%20clean%20neutral%20background%2C%20business%20casual%20style&width=120&height=120&seq=avatar-zhang-03&orientation=squarish",
    content: "创业初期预算紧张，请不起设计师。黄油网站解决了我们所有的设计需求，从Logo到宣传物料，一个平台全搞定。现在公司规模大了，但黄油网站依然是团队标配。",
    rating: 5,
  },
  {
    id: "test-004",
    name: "陈思雨",
    role: "自媒体博主",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20woman%20content%20creator%20with%20warm%20friendly%20smile%2C%20natural%20soft%20lighting%2C%20clean%20beige%20background%2C%20casual%20creative%20style&width=120&height=120&seq=avatar-chen-04&orientation=squarish",
    content: "小红书封面、视频封面、公众号头图，这些以前是我最头疼的事。用了黄油网站以后，封面制作变成了一种享受。图文制作功能特别适合我这种审美不过关的人！",
    rating: 4,
  },
  {
    id: "test-005",
    name: "刘浩然",
    role: "品牌营销经理",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20business%20professional%20with%20glasses%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20confident%20approachable%20expression&width=120&height=120&seq=avatar-liu-05&orientation=squarish",
    content: "我们公司的品牌视觉一直依赖外部设计公司，成本高、周期长。引入黄油网站后，内部团队可以快速完成80%的日常设计需求，大大降低了成本。素材库的商业授权也让我们用着放心。",
    rating: 5,
  },
  {
    id: "test-006",
    name: "赵雪儿",
    role: "大学生",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20female%20student%20with%20bright%20smile%2C%20natural%20daylight%2C%20clean%20minimal%20background%2C%20youthful%20fresh%20aesthetic&width=120&height=120&seq=avatar-zhao-06&orientation=squarish",
    content: "社团海报、活动传单、PPT美化，黄油网站是我大学生涯里发现的最实用的工具！免费模板就足够用了，操作也很简单，室友被我安利了一圈。",
    rating: 5,
  },
];